import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-exam-sub',
  templateUrl: './exam-sub.component.html',
  styleUrls: ['./exam-sub.component.scss']
})
export class ExamSubComponent implements OnInit {
  ExamSubForm: FormGroup;
  selectedIndex: number = 0;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  examSubList: any;
  list;
  ExamSubSearchForm;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  isreaddelete: boolean;
  deleteButton: boolean;
  courselist: any;
  filteredListCourse: any;
  StrIdList: any;
  filteredListStrId: any;
  examList: any;
  filteredListexam: any;
  examSemList: any;
  GroupDisabled = true;
  SubDisabled = true;
  PartDisabled = true;
  InPartDisabled = true;
  HeadDisabled = true;
  ChoiceSubDisabled = true;
  filteredListexamSem: any;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute,) { this.APIService = environment.serviceUrl; }
  ngOnInit(): void {
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.list = true;
    this.ExamSubForm = this.fb.group({
      EmSubCourse: new FormControl(''),
      EmSubExam: new FormControl('',),
      EmSubStrId: new FormControl('',),
      EmSubCode: new FormControl('',),
      EmSubCoType: new FormControl('',),
      EmSubPType: new FormControl('',),
      EmSubShName: new FormControl('',),
      EmSubName: new FormControl('',),
      EmSubLang: new FormControl('',),
      EmSubOption: new FormControl('',),
      EmSubPrint: new FormControl('',),
      EmSubParent: new FormControl(''),
      EmSubMustOff: new FormControl(''),
      EmSubCantOff: new FormControl(''),
      EmSubTotal: new FormControl(''),
      EmSubSem: new FormControl(''),
      EmSubOldCo: new FormControl(''),
      EmSubRead: new FormControl('')

    });
    this.ExamSubSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.fetchCourse(id);
    this.fetchExam(id);
    this.fetchExamSem(id);
    this.fetchStrId(id);
    this.getExamSubData();
  }

  keypress() {
    // this.umsService.searchExamSub(this.ExamSubSearchForm
    //   .value).subscribe(res => {
    //     this.examSubList = res.data;
    //   }, (ERROR: HttpErrorResponse) => {
    //     this.examSubList = [];
    //   });
  }

  // download() {
  //   let wwe = ['EdSrNo', 'EdDiv', 'EdEsThPr', 'EdEsId', 'EdMarksPC', 'EdGrade']
  //   this.umsService.downloadFile(this.examSubList, 'jsontocsv', wwe);
  // }

  getExamSubData() {
  }

  deletee() {
    // if (e === 'true') {
    //   this.list = false;
    //   this.getExamSubData(id);
    //   this.prepopulationForDelete(k);
    // } else {
    //   this.list = true;
    // }
  }

  submit() {
    if (this.ExamSubForm.valid) {
      this.createExamSub();
      this.getExamSubData();
    }
  }

  createExamSub() {
    this.submitpayload = this.ExamSubForm.value;
    // this.umsService.addExamDiv(this.submitpayload).subscribe(res => {
    //   if (res.status) {
    //     let data = {}
    //     data['message'] = res.message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-check'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     // this.dialogRef.afterClosed().subscribe(result => {
    //       this.ngOnInit();
    //     // });
    //   } else {
    //     let data = {}
    //     data['message'] = res.message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-close'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     // this.dialogRef.afterClosed().subscribe(result => {
    //     //   this.ngOnInit();
    //     // });
    //   }
    // });
  }

  prepopulationForDelete() {
    const payload = {};
    // payload['EdEmId'] = id;
    // payload['EdStrId'] = id;
    // payload['EdMarksType'] = id;
    // this.umsService.getExamDiv(payload).subscribe((res) => {
    //   const data = res.data[0];
    //   if (res.status) {
    //     this.editButton = false;
    //     this.submitButton = false;
    //     this.isreaddelete = true;
    //     this.deleteButton = true;
    //     this.ExamSubForm = this.fb.group({
    //       EmName: new FormControl(data.EmName),
    //       EdEmId: new FormControl(data.EdEmId),
    //       EdStrId: new FormControl(data.EdStrId),
    //       EdSrNo: new FormControl(data.EdSrNo),
    //       EdEsThPr: new FormControl(data.EdEsThPr),
    //       EdEsId: new FormControl(data.EdEsId),
    //       EdDiv: new FormControl(data.EdDiv, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
    //       EdMarksPC: new FormControl(data.EdMarksPC, [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$')]),
    //       EdGrade: new FormControl(data.EdGrade,),
    //       EdMarksType: new FormControl(data.EdMarksType,)

    //     });
    //   } else {
    //     let data = {}
    //     // tslint:disable-next-line:no-string-literal
    //     data['message'] = res.message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-box-open'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   }
    // });
  }

  openConformationModalBox() {
    const data = {};
    // tslint:disable-next-line:no-string-literal
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    // tslint:disable-next-line:no-string-literal
    data['title'] = 'Alert';
    // tslint:disable-next-line:no-string-literal
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamSubForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(id) {
    // const options = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //   }), body: {
    //     EdEmId: id.EdEmId,
    //     EdStrId: id.EdStrId,
    //     EdSrNo: id.EdSrNo,
    //     EdEsThPr: id.EdEsThPr,
    //     EdEsId: id.EdEsId,
    //     EdDiv: id.EdDiv,
    //     EdMarksPC: id.EdMarksPC,
    //     EdGrade: id.EdGrade,
    //     EdMarksType: id.EdMarksType,

    //   },
    // };
    // this.httpClient.delete(this.APIService + '/masters/exam-division', options)
    //   .subscribe((s) => {
    //     let cc = [];
    //     cc.push(s);
    //     let data = {}
    //     data['message'] = cc[0].message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-check'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     this.dialogRef.afterClosed().subscribe(result => {
    //       this.ngOnInit();
    //     });
    //   }, (ERROR: HttpErrorResponse) => {
    //     let data = {}
    //     data['message'] = ERROR.error.message
    //     data['title'] = 'Alert'
    //     data['icon'] = 'fas fa-close'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     this.ngOnInit();
    //     // this.umsService.openSnackbar(ERROR.error.message);

    //   });

  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.ExamSubForm.reset();
      // this.ExamSubForm = this.fb.group({
      //   EmSubCourse: new FormControl(''),
      //   EmSubExam: new FormControl('',),
      //   EmSubStrId: new FormControl('',),
      //   EmSubCode: new FormControl('',),
      //   EmSubCoType: new FormControl('',),
      //   EmSubPType: new FormControl('',),
      //   EmSubShName: new FormControl('',),
      //   EmSubName: new FormControl('',),
      //   EmSubLang: new FormControl('',),
      //   EmSubOption: new FormControl('',),
      //   EmSubPrint: new FormControl('',),
      //   EmSubParent: new FormControl(''),
      //   EmSubMustOff: new FormControl(''),
      //   EmSubCantOff: new FormControl(''),
      //   EmSubTotal: new FormControl(''),
      //   EmSubSem: new FormControl(''),
      //   EmSubOldCo: new FormControl(''),
      //   EmSubRead: new FormControl('')
      // });
    } else {
      this.list = true;
    }

  }

  fetchCourse(id) {
    const payload = {};
    payload['CoFcCode'] =  id,
    payload['CoCode'] = id,
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.courselist = res.data;
        this.filteredListCourse = this.courselist.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });

  }

  fetchStrId(id) {
    const payload = {};
    payload['StrId'] = id;
    payload['StrName'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.StrIdList = res.data;
        this.filteredListStrId = this.StrIdList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  back() {
     
  }

  fetchExam(data) {
    const payload = {};
    payload['EmCoCode'] = data;
    payload['EmId'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.examList = res.data;
        this.filteredListexam = this.examList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchExamSem(data) {
    const payload = {};
    payload['SeEmId'] = data;
    // /api/v1/masters/code/fetch
    this.umsService.getExamSem(payload).subscribe(res => {
      if (res.status) {
        this.examSemList = res.data;
        this.filteredListexamSem = this.examSemList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.isread = false;
      this.getExamSubData();
      // this.facultyform = k;
      // this.prepopulation(this.facultyform);
    } else {
      this.list = true;
    }
  }

  update(){
    if (this.ExamSubForm.invalid) {
      // this.ExamSubForm.get('FcCode').markAsTouched();
      // this.ExamSubForm.get('FcDesc').markAsTouched();
      return;
    } else {
      this.updateFaculty();
    }
  }

  updateFaculty() {
    // 403 code error handling needed to be given
    this.submitpayload = this.ExamSubForm.value;
    this.umsService.updateFaculty(this.submitpayload).subscribe(res => {
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       // this.umsService.openSnackbar(res.message);
        // this.ngOnInit();
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.umsService.openSnackbar(res.message);
        // this.ngOnInit();
      }
    });
  }

}
